module.exports = __webpack_public_path__ + "static/media/01-mobile.60451217.webp";